import { Typography } from '@material-ui/core';
import styled from 'styled-components';
import { formatDate } from '@superdispatch/dates';
import { Stack, ColorDynamic } from '@superdispatch/ui';
import { LoadDTO } from '../data/LoadDTO';
import { ViewLoadLegNotes } from './ViewLoadLegNotes';
import { ViewLoadPaymentCardRow } from './ViewLoadPaymentRenderCardRow';

export const PaymentDetailsWithBorder = styled.div`
  border-left: 1px solid ${ColorDynamic.Silver500};
  margin-left: 7px;
  padding-left: 12px;
`;

interface InvoiceDetailsParams {
  customerInvoice: LoadDTO['customer_invoice'];
  defaultValuePlaceholder: string;
}
export function ViewCustomerInvoiceDetails({
  customerInvoice,
  defaultValuePlaceholder,
}: InvoiceDetailsParams) {
  return (
    <PaymentDetailsWithBorder>
      <Stack space="xsmall">
        <ViewLoadPaymentCardRow
          title="Invoice №"
          value={customerInvoice?.number || defaultValuePlaceholder}
        />

        <ViewLoadPaymentCardRow
          title="Sent date"
          value={
            customerInvoice?.sent_at
              ? formatDate(customerInvoice.sent_at, {
                  variant: 'DateTime',
                })
              : defaultValuePlaceholder
          }
        />

        {!!customerInvoice?.invoice_notes && (
          <Stack>
            <Typography color="textSecondary">Notes</Typography>
            <ViewLoadLegNotes
              content={customerInvoice.invoice_notes}
              data-e2e="payment.invoice.invoice_notes"
            />
          </Stack>
        )}
      </Stack>
    </PaymentDetailsWithBorder>
  );
}
